<template>
  <VLoader v-if="videosLoading" />
  <section v-else class="shared-section">
    <SeriesHeader
      title="Training Videos"
      :serie="serie"
      :videoTitle="videoTitle"
      :showVideoDetails="isViewRoute"
      @show="showModal = true"
    />

    <div class="flex items-start h-full">
      <SeriesSidebar :series="series" :selectedSerie="serie" @select="handleSerie" />

      <div class="relative self-stretch flex-1">
        <router-view
          :key="$route.path"
          :showModal="showModal"
          :serie="serie"
          :language="language"
          @close="showModal = false"
          @edit="title => (videoTitle = title)"
        ></router-view>
      </div>
    </div>
  </section>
</template>

<script>
import VLoader from '@/components/base/VLoader';
import SeriesHeader from '@/components/admin/SeriesHeader';
import SeriesSidebar from '@/components/admin/SeriesSidebar';

import { videosMixin } from '@/mixins';

export default {
  name: 'AdminTrainingVideos',
  components: {
    VLoader,
    SeriesSidebar,
    SeriesHeader,
  },
  mixins: [videosMixin('training-videos')],
};
</script>
